import React from "react";
import { Route, Routes } from "react-router-dom";
import Login from "../pages/Login/Login";
import ForgotPassword from "../pages/ForgotPassword/ForgotPassword";
import NoAccessPages from "../pages/NoAcessPages/NoAcessPages";
import RecoverPassword from "../pages/RecoverPassword/RecoverPassword";
import Authorization from "../pages/Authorization/Authorization";
import GuardedRoute from "../guards/GuardedRoute";
import Archive from "../pages/Archive/Archive";
import Basket from "../pages/Basket/Basket";
import UserMonitor from "../pages/UserMonitor/UserMonitor";
import Reference from "../pages/Reference/Reference";
import Projects from "../pages/Projects/Projects";
import Task from "../pages/Task/Task";
import Project from "../pages/Project/Project";
import SystemSettings from "../pages/SystemSettings/SystemSettings";
import Feedback from "../pages/Feedback/Feedback";
import GlobalSearch from "../pages/GlobalSearch/GlobalSearch";
import NoLicense from "../pages/NoLicense/NoLicense";
import Store from "../store/store";
import Board from "../pages/Board/Board";
import LoginToken from "../pages/Token/LoginToken";

interface AppRoutesProps {
    store: Store; 
}

const AppRoutes: React.FC<AppRoutesProps> = ({ store }) => {
    return (
        <Routes>
            <Route path="/login/token" element={<LoginToken />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgotPassword" element={<ForgotPassword />} />
            <Route path="/noAccessPages" element={<NoAccessPages />} />
            <Route path="/noAccessPages/:token" element={<NoAccessPages />} />
            <Route path="/recoverPassword/:token" element={<RecoverPassword />} />
            <Route path="/register" element={<Authorization />} />
            <Route path="/*" element={
                    <GuardedRoute condition={store.isAuth && store.isActivate}>
                        {store.getAvailableModules().base ? (
                            <Routes>
                                <Route path="/archive" element={<Archive />} />
                                <Route path="/basket" element={<Basket />} />
                                <Route path="/monitor" element={<UserMonitor />} />
                                <Route path="/reference" element={<Reference />} />
                                <Route path="/projects" element={<Projects />} />
                                <Route path="/task/:id" element={<Task />} />
                                <Route path="/archive/task/:id" element={<Task />} />
                                <Route path="/board/:boardId/task/:id" element={<Task />} />
                                <Route path="/archive/board/:boardId/task/:id" element={<Task />} />
                                <Route path="/project/:id" element={<Project />} />
                                <Route path="/archive/project/:id" element={<Project />} />
                                <Route path="/board/:boardId" element={<Board />} />
                                <Route path="/archive/board/:boardId" element={<Board />} />
                                <Route path="/system/settings" element={<SystemSettings />} />
                                <Route path="/feedback" element={<Feedback />} />
                                <Route path="/globalsearch" element={<GlobalSearch />} />
                                <Route path="*" element={<Projects />} />
                            </Routes>
                        ) : (
                            <Routes>
                                <Route path="/noLicense" element={<NoLicense />} />
                                <Route path="*" element={<NoLicense />} />
                            </Routes>
                        )}
                    </GuardedRoute>
                }
            />
            <Route path="*" element={<Login />} />
        </Routes>
    );
};

export default AppRoutes;
